export default "__VITE_ASSET__CLw2lxjr__"